<!-- 顶部LOGO、搜索栏、导航栏组件 -->
<template>
  <div class="zixun">
      <div class="top">
        <div class="left" v-if="type==='modal'">
          <div>{{ language.downloadTitle }}</div>
          <div>{{ language.downloadDesc }}</div>
        </div>
        <div class="left" v-else>
          <div>{{ language.consultTitle }}</div>
          <div v-if="$store.state.pageType == 1">{{ language.consultDesc }}<span>sales@corepilot-semi.com</span></div>
          <div v-else>{{ language.consultDesc }}</div>
        </div>
        <div v-if="$store.state.sizeType == 'pc'" class="btn" @click="submit()">{{ language.submit }} <img
            src="../assets/home/arrow-right-line.png">
        </div>
      </div>

      <div class="form" :class="{ 'is-submitted': submitted }">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
          <div class="line">
            <FormItem :label="language.name" prop="userName">
              <Input v-model="formValidate.userName" :placeholder="language.namePlaceholder"></Input>
            </FormItem>
            <FormItem :label="language.company" prop="companyName">
              <Input v-model="formValidate.companyName" :placeholder="language.companyPlaceholder"></Input>
            </FormItem>
          </div>

          <div class="line">
            <FormItem :label="language.jobTitle" prop="position">
              <Input v-model="formValidate.position" :placeholder="language.jobTitlePlaceholder"></Input>
            </FormItem>
            <FormItem :label="language.email" prop="email">
              <Input v-model="formValidate.email" :placeholder="language.emailPlaceholder"></Input>
            </FormItem>
          </div>

          <div class="line">
            <FormItem :label="language.phone" prop="telNo">
              <Input v-model="formValidate.telNo" :placeholder="language.phonePlaceholder"></Input>
            </FormItem>
            <FormItem v-if="type==='modal'" :label="language.downloadReason" prop="content">
              <Input v-model="formValidate.content" type="textarea" :autosize="{ minRows: 5, maxRows: 15 }"
                :placeholder="language.downloadReasonPlaceholder"></Input>
            </FormItem>
            <FormItem v-else :label="language.inquiry" prop="content">
              <Input v-model="formValidate.content" type="textarea" :autosize="{ minRows: 5, maxRows: 15 }"
                :placeholder="language.inquiryPlaceholder"></Input>
            </FormItem>
            <!-- <FormItem label="验证码：" prop="name">
              <Input on-search="" v-model="formValidate.name" placeholder="请输入收到的验证码" search
                enter-button="获取验证码"></Input>
            </FormItem> -->
          </div>

          <!-- <div class="line">
            <FormItem label="问题咨询：" prop="content">
              <Input v-model="formValidate.content" type="textarea" :autosize="{ minRows: 5, maxRows: 15 }"
                placeholder="请输入您要咨询的问题"></Input>
            </FormItem>
          </div> -->

        </Form>

        <div v-if="$store.state.sizeType == 'phone'" class="btn" @click="submit()">{{ language.submit }} <img
            src="../assets/home/arrow-right-line.png">
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'form2',
  inject: ['reload'],
  props: ["name", "key2", "type"],
  data() {
    return {
      formValidate: {},
      language: {},
      submitted: false,
    };
  },
  computed: {
    ruleValidate() {
      return {
        userName: [
          { required: true, message: this.language.required }
        ],
        companyName: [
          { required: true, message: this.language.required }
        ],
        content: [
          { required: true, message: this.language.required }
        ],
        position: [
          { required: true, message: this.language.required }
        ],
        telNo: [
          { required: true, message: this.language.required },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: this.language.phoneInvalid,
          }
        ],
        email: [
          { required: true, message: this.language.required },
          {
            type: 'email',
            message: this.language.emailInvalid,
          }
        ]
      };
    },
  },
  methods: {
    submit() {
      const forbiddenDomains = [
        'qq.com',
        '163.com',
        '126.com'
      ]
      this.submitted = true;
      this.$nextTick(() => {
        this.$refs.formValidate.validate(valid => {
          if (!valid) {
            return;
          }
          const email = this.formValidate.email || '';
          const domain = email.split('@')[1];
          if (domain && forbiddenDomains.includes(domain.toLowerCase())) {
            this.$Message.error(this.language.emailForbidden)
            return
          }
          this.$config('/open/api/email/send', { ...this.formValidate, productId: this.key2, fileName: this.name }).then(res => {
            this.submitted = false;
            this.$refs.formValidate.resetFields();
            this.formValidate = {};
            if(this.type==='modal'){
              this.$Modal.confirm({
                title: this.language.tipTitle,
                content: this.language.tipContent,
                okText: this.language.okText,
                cancelText: this.language.cancelText,
              })
            } else {
              this.$Message.success(this.language.success)
            }
            this.$emit('close');
          }).catch(err => { })
        })
      })
    },
  },
  created() {
    this.language = this.$language[this.$store.state.pageType].form;
  },
};
</script>

<style scoped lang='scss'>
  .zixun {
    padding: 0.95rem calc(50% - 600px);

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        // font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 24px;
        color: #000000;

        div:last-child {
          // font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          margin-top: 0.3rem;

          span {
            color: #004CFA;
          }
        }
      }

      .btn {
        width: 2.22rem;
        height: 0.79rem;
        background: #00B4A9;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.25rem;
        // font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 0.24rem;
        color: #FFFFFF;
        cursor: pointer;

        img {
          width: 0.28rem;
          height: 0.28rem;
        }
      }
    }

    .form {
      &:not(.is-submitted) >>> .ivu-form-item-error-tip {
        display: none;
      }
    }

    form {
      padding: 0.8rem 0;

      .line {
        display: flex;
        justify-content: space-between;

        &>div {
          width: calc(50% - 0.2rem);
        }

        &>>>.ivu-form-item {
          width: calc(50% - 0.2rem);

          .ivu-form-item-label {
            font-size: 0.24rem;
            color: #333333;
            // font-family: Source Han Sans CN, Source Han Sans CN;
            margin-bottom: 0.12rem;
          }

          input {
            height: 0.64rem;
            font-size: 0.24rem;
            padding-left: 0.15rem;
          }

          textarea {
            font-size: 0.24rem;
            padding-left: 0.15rem;
          }

          .ivu-form-item-error-tip {
            font-size: 0.24rem;
            padding-top: 0.15rem;
          }

          .ivu-input-search {
            font-size: 0.24rem;
            background-color: #00B4A9 !important;
            border: none;
            width: 1.96rem;
          }

          .ivu-form-item-error-tip{
            font-size: 0.14rem;
            padding-top: 0.08rem;
          }
        }



        // &:last-child {
        //   & > div {
        //     width: 100%;
        //   }
        //   &>>>.ivu-form-item {
        //     width: 100%;
        //   }
        // }
      }
    }
  }

  @media screen and (max-width: 750px){
    .zixun {
      padding: 0.95rem 0.6rem;

      .top {
        .left {
          font-weight: 500;
          font-size: 0.32rem;

          div:last-child {
            font-size: 0.24rem;
            line-height: 0.58rem;
            padding-right: .7rem;
          }
        }
      }

      .form {
        form {
          .line {
            display: block;

            &>div {
              width: 100%;
            }

            &>>>.ivu-form-item {
              width: 100%;

              .ivu-form-item-error-tip{
                font-size: 0.18rem;
              }
            }

            &:last-child {
              &>div:last-child {
                margin-bottom: 0;
              }
            }
          }


        }

        .btn {
          width: 100%;
          height: .79rem;
          background: #00B4A9;
          border-radius: 4px 4px 4px 4px;
          // font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 0.24rem;
          color: #FFFFFF;
          line-height: .79rem;
          text-align: center;
        }
      }

      .pdf {
        padding-top: .9rem;

        .one {
          width: 100%;
          height: 2.06rem;
          padding-left: .3rem;

          .right {
            .top {
              font-size: 0.24rem;
              width: calc(100% - 0.8rem);
              word-break: break-all;
            }

            .bottom {
              font-size: 0.18rem;
              margin-top: .25rem;
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/form2.vue